// =============================================================================
// Desktop money helpers — thin shim that re-exports from /shared/.
// New code: prefer the canonical names imported directly from shared/.
//
// Desktop's historical names (preserved exactly):
//   fmtK      → fmtKwachaLocale (locale + 2dp)
//   fmtKShort → "K500" / "K1.2k" (locale no decimals, abbreviated for >=1000)
// =============================================================================

import { fmtKwachaLocale } from "../../../shared/currency.js";

export { fmtKwachaLocale } from "../../../shared/currency.js";

// Prices are stored in ngwee (1 Kwacha = 100 ngwee). Always divide by 100.
export function fmtK(ngwee) {
  return fmtKwachaLocale(ngwee);
}

// Desktop's fmtKShort: locale no decimals for <1000, "K1.2k" for >=1000.
// This is slightly different from mobile's fmtKShort (which rounds to whole
// kwacha for both ranges), so we keep it as a desktop-local function.
export function fmtKShort(ngwee) {
  const kwacha = Number(ngwee || 0) / 100;
  if (kwacha >= 1000) return "K" + (kwacha / 1000).toFixed(1) + "k";
  return "K" + kwacha.toLocaleString("en-US", { maximumFractionDigits: 0 });
}
